import React, { useEffect, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setIsSidebarOpen } from "context/features/dataSlice";
import News from "features/News";
import BookmarkDrawer from "features/Bookmarks";
import SourceSidebar from "features/SourceInfo";
import { useSourceData } from "features/SourceInfo/hooks/use-source-data.hooks";

const Newspage = () => {
  const { isSidebarOpen } = useSelector((state) => state.data);
  const { isSourceSidebarOpen } = useSourceData();

  const dispatch = useDispatch();
  const anyOpen = isSidebarOpen || isSourceSidebarOpen;

  const sidebarClosedHandler = () => {
    dispatch(setIsSidebarOpen(false));
    document.body.style.overflow = "unset";
  };

  const showSidebar = () => {
    dispatch(setIsSidebarOpen(true));
  };

  useEffect(() => {
    if (anyOpen) {
      const scrollBarWidth =
        window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = "hidden";
      document.body.style.paddingRight = `${scrollBarWidth}px`;
    } else {
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    }
  }, [anyOpen]);

  return (
    <Fragment>
      <News />
      <BookmarkDrawer
        isSidebarOpen={isSidebarOpen}
        sidebarClosedHandler={sidebarClosedHandler}
        showSidebar={showSidebar}
      />

      <SourceSidebar />
    </Fragment>
  );
};

export default Newspage;
